module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yLjAyMjIzIDAuODEzNDc3SDExLjk3NzhDMTIuNjYyMiAwLjgxMzQ3NyAxMy4yMjIyIDEuMzczNDggMTMuMjIyMiAyLjA1NzkyVjEzLjI1NzlMMTAuNzMzMyAxMC43NjlIMi4wMjIyM0MxLjMzNzc4IDEwLjc2OSAwLjc3Nzc4NCAxMC4yMDkgMC43Nzc3ODQgOS41MjQ1OVYyLjA1NzkyQzAuNzc3Nzg0IDEuMzczNDggMS4zMzc3OCAwLjgxMzQ3NyAyLjAyMjIzIDAuODEzNDc3WiIgZmlsbD0iIzQ0NDU0NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message.svg
// module id = L3F/
// module chunks = 1